import {FetchStatus} from '../common/FetchStatus.enum';
import useTypedSelector from '../common/useTypedSelector';
import {SectionEntity} from './types';

export function useSelectSection(id: string): {
  section: SectionEntity;
  fetchStatus: FetchStatus;
  error: Error;
} {
  const result = useTypedSelector(state => {
    const section = state.pagewebLayout.entities.sections[id];
    const fetchStatus = state.pagewebLayout.fetchStatus[id];
    const error = state.pagewebLayout.errors[id];
    return {
      section,
      fetchStatus,
      error,
    };
  });
  return result;
}
